@if (!isRedTheme) {
  <div>
    <button type="button" mat-raised-button
      class="increment-stepper__icon-button"
      [disabled]="disableDecrement"
      (click)="$event.stopPropagation(); decrement()">
      <mat-icon class="increment-stepper__icon">remove</mat-icon>
    </button>
    <span class="increment-stepper__value">{{numberSelected}}</span>
    <button type="button" mat-raised-button
      class="increment-stepper__icon-button"
      [disabled]="disableIncrement"
      (click)="$event.stopPropagation(); increment()">
      <mat-icon class="increment-stepper__icon">add</mat-icon>
    </button>
  </div>
}
@if (isRedTheme) {
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    class="increment-stepper-restyle">
    <button type="button" mat-raised-button
      class="increment-stepper-restyle__remove increment-stepper-restyle__button"
      [ngClass]="{'increment-stepper-restyle__button-disabled': disableDecrement}"
      [disabled]="disableDecrement"
      (click)="$event.stopPropagation(); decrement()">
      <mat-icon class="increment-stepper-restyle__icon"
        [ngClass]="{'increment-stepper-restyle__icon-disabled': disableDecrement}">
        remove
      </mat-icon>
    </button>
    <span class="increment-stepper-restyle__number"
      [ngClass]="{'increment-stepper-restyle__disabled-number': disableIncrement && disableDecrement}">
      {{numberSelected}}
    </span>
    <button type="button" mat-raised-button
      class="increment-stepper-restyle__add increment-stepper-restyle__button"
      [ngClass]="{'increment-stepper-restyle__button-disabled': disableIncrement}"
      [disabled]="disableIncrement"
      (click)="$event.stopPropagation(); increment()">
      <mat-icon class="increment-stepper-restyle__icon"
        [ngClass]="{'increment-stepper-restyle__icon-disabled': disableIncrement}">
        add
      </mat-icon>
    </button>
  </div>
}
